export const capitalize = (str: string = "") =>
  str.charAt(0).toUpperCase() + str.slice(1);

/** "1 role" / "2 roles": picks the label that matches `n`. */
export function pluralize(n: number, singular: string, plural: string): string {
  return n === 1 ? singular : plural;
}
